$(document).on('change', '.js_ads_checked_no_end_date', function(e) {
  if ($('.js_ads_checked_no_end_date').is(":checked")) {
    $('.js_ads_end_date').attr("disabled", "disabled");
  } else {
    $('.js_ads_end_date').attr("disabled", false);
  }
});